import { MinimalCard } from 'components/styled';
import { EntityMappingStatusForm } from './components/EntityMappingStatusForm';

export const EntityMappingStatusCard = () => {
  return (
    <MinimalCard sx={{ height: '100%' }}>
      <EntityMappingStatusForm />
    </MinimalCard>
  );
};
